// SidePanel.js
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { sidePanelActions } from '_store/sidePanel.slice';
import { getIcons } from '_helpers';
import { SidePanelLayout } from 'views/sidePanels';

export { SidePanel };

function SidePanel() {
    const dispatch = useDispatch();
    const { isOpen } = useSelector((state) => state.sidePanel);

    if (!isOpen) {
        return null;
    }

    return (
        <div className={`side-panel-container ${isOpen ? 'open' : ''}`}>
            <div className="overlay" onClick={() => dispatch(sidePanelActions.closePanel())}></div>
            <button className="chevron bookmark">
                    <img
                        src={getIcons('arrowBackIosNewOutlinedWhite')}
                        alt="bookmark"
                        onClick={() => dispatch(sidePanelActions.closePanel())}
                        className="retourner-180"
                    />
                </button>
            <div className="side-panel">
                
                <div className="side-panel-header">
                    <button className="btn-custom btn-custom-primary" onClick={() => dispatch(sidePanelActions.closePanel())}>
                        <img src={getIcons("clearOutlinedWhite")} className="btn-custom-icon" alt="close" />
                        Fermer
                    </button>
                </div>
                <div className="side-panel-content">
                    <SidePanelLayout />
                </div>
            </div>
        </div>
    );
};